import RenderDateWithFromTime from '@/common-utils/components/renders/date/RenderDateWithFromTime';
import RenderApplication from '../../application/RenderApplication';
import RenderBankCode from '../../bankCode/RenderBankCode';
import generateColumnDefByField from '@/common-utils/functions/generateColumnDefByField';
import PosTerminalLocation from '@/app/modules/terminals/components/location/PosTerminalLocation';
import contractFields from '../../../fields/contractFields';
import RenderPosTerminalConnectionType from '@/app/modules/terminals/components/renders/connectionType/RenderPosTerminalConnectionType';
import getObjectAttributeFromStringKey from '@/common-utils/functions/getObjectAttributeFromStringKey';
import generateNestedFieldAccessor from '@/common-utils/functions/generateNestedFieldAccessor';
import NETWORK_INTERFACE_TYPE from '@/app/modules/terminals/enums/NetworkInterfaceType';
import getIccidWithoutPrefix from '@/common-utils/functions/getIccidWithoutPrefix';
import RenderSimOperator from '@/app/modules/sims/components/simOperator/RenderSimOperator';
import DropdownTerminalContractActionsRow from '../../dropdown/DropdownTerminalContractActionsRow';

export const columnsTerminalContractId = 'terminalContracts';
export const columnsTerminalContract = (headerPackage) => {
    const show = true;

    return ([
        // Columns
        generateColumnDefByField({
            field: contractFields.LAST_SOURCE_IP,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => {
                const posTerminalUuid = getObjectAttributeFromStringKey(
                    cell.row.original,
                    contractFields.POS_TERMINAL.key);
                const connectionType = getObjectAttributeFromStringKey(
                    cell.row.original,
                    contractFields.LAST_CONNECTION_TYPE.key);
                const sourceIp = getObjectAttributeFromStringKey(
                    cell.row.original,
                    contractFields.LAST_SOURCE_IP.key);
                return (
                    cell &&
                    <PosTerminalLocation
                        connectionType={connectionType}
                        sourceAddressIp={sourceIp}
                        posTerminalUuid={posTerminalUuid}
                    />
                );
            },
            show: !headerPackage.selectionMode
        }),
        generateColumnDefByField({
            field: contractFields.UUID,
            headerPackage: headerPackage,
            customCellFn: ({ row }) => (
                row &&
                <DropdownTerminalContractActionsRow contract={row.original} setLaunchRefetch={headerPackage.setLaunchRefetch} />
            ),
            show: !headerPackage.selectionMode
        }),
        generateColumnDefByField({
            field: contractFields.APPLICATION,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => {
                if (!cell) {
                    return null;
                }
                const itp = getObjectAttributeFromStringKey(cell.row.original, generateNestedFieldAccessor(contractFields.ITP)) || '';
                const posTerminalSerialNumber = getObjectAttributeFromStringKey(cell.row.original, generateNestedFieldAccessor(contractFields.POS_TERMINAL.SERIAL_NUMBER))
                    || '';
                return (
                    <RenderApplication
                        itp={itp}
                        applicationCode={cell.getValue(contractFields.APPLICATION.key)}
                        posTerminalSerialNumber={posTerminalSerialNumber}
                    />
                );
            }
        }),
        generateColumnDefByField({
            field: contractFields.LAST_REMOTE_COLLECTION_DATE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime
                    value={cell.getValue(contractFields.LAST_REMOTE_COLLECTION_DATE.key)}
                />
            )
        }),
        generateColumnDefByField({
            field: contractFields.LABEL,
            headerPackage: headerPackage,
            isLongText: true
        }),
        generateColumnDefByField({
            field: contractFields.NUMBER,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: contractFields.RANK,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: contractFields.BANK_CODE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderBankCode bankCode={cell.getValue(contractFields.BANK_CODE.key)} />
            )
        }),
        generateColumnDefByField({
            field: contractFields.X25_ADDRESS,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                <small>{cell.getValue(contractFields.X25_ADDRESS.key)}</small>
            )
        }),
        generateColumnDefByField({
            field: contractFields.REGISTRATION_NUMBER,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                <small>{cell.getValue(contractFields.REGISTRATION_NUMBER.key)}</small>
            )
        }),
        generateColumnDefByField({
            field: contractFields.LEGAL_AND_BUSINESS_NAME,
            headerPackage: headerPackage,
            isLongText: true
        }),
        generateColumnDefByField({
            field: contractFields.ITP,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                <small>{cell.getValue(contractFields.ITP.key)}</small>
            )
        }),
        generateColumnDefByField({
            field: contractFields.CB_VERSION,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell && cell.getValue(contractFields.CB_VERSION.key) &&
                <span>{cell.getValue(contractFields.CB_VERSION.key).replace(/^CB/, '')}</span>
            )
        }),
        generateColumnDefByField({
            field: contractFields.CREATED_AT,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(contractFields.CREATED_AT.key)} />
            )
        }),
        generateColumnDefByField({
            field: contractFields.LAST_ICCID,
            customCellFn: ({ cell }) => {
                const lastConnectionType = getObjectAttributeFromStringKey(
                    cell.row.original,
                    generateNestedFieldAccessor(contractFields.LAST_CONNECTION_TYPE));
                const isLastConnectionTypeGPRS = lastConnectionType === NETWORK_INTERFACE_TYPE.GPRS.name;
                const lastIccidOperator = getObjectAttributeFromStringKey(
                    cell.row.original,
                    generateNestedFieldAccessor(contractFields.LAST_ICCID_OPERATOR));

                return (
                    isLastConnectionTypeGPRS ?
                        <div>
                            <div>
                                <small>
                                    {
                                        getIccidWithoutPrefix(
                                            getObjectAttributeFromStringKey(
                                                cell.row.original,
                                                generateNestedFieldAccessor(contractFields.LAST_ICCID)
                                            )
                                        )
                                    }
                                </small>
                            </div>
                            <div>
                                <RenderSimOperator
                                    iccidOperators={lastIccidOperator} />
                            </div>
                        </div>
                        :
                        cell &&
                        <small>{cell.getValue(contractFields.LAST_ICCID.key)}</small>
                );
            },
            headerPackage: headerPackage,
            show: show
        }),
        generateColumnDefByField({
            field: contractFields.LAST_CONNECTION_TYPE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => {
                const lastIccidOperator = (getObjectAttributeFromStringKey(cell.row.original,
                    generateNestedFieldAccessor(contractFields.LAST_ICCID_OPERATOR)));
                return (
                    cell &&
                    <RenderPosTerminalConnectionType
                        connectionType={cell.getValue(contractFields.LAST_CONNECTION_TYPE.key)}
                        iccidOperators={lastIccidOperator}
                        iconOnly
                    />
                );
            }
        }),
        generateColumnDefByField({
            field: contractFields.REMPART.MODEL,
            headerPackage: headerPackage,
            show: show
        }),
        generateColumnDefByField({
            field: contractFields.REMPART.SPECIFICATION,
            headerPackage: headerPackage,
            show: show
        }),
        generateColumnDefByField({
            field: contractFields.REMPART.BULLETINS,
            headerPackage: headerPackage,
            show: show
        }),
        generateColumnDefByField({
            field: contractFields.REMPART.ERT_CODE,
            headerPackage: headerPackage,
            show: show
        }),
        generateColumnDefByField({
            field: contractFields.REMPART.CB_APPROVAL,
            headerPackage: headerPackage,
            show: show
        }),
        generateColumnDefByField({
            field: contractFields.REMPART.CB_APPROVAL_DATE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(contractFields.REMPART.CB_APPROVAL_DATE.key)} />
            ),
            show: show
        }),
        generateColumnDefByField({
            field: contractFields.REMPART.PCI_VERSION,
            headerPackage: headerPackage,
            show: show
        }),
        generateColumnDefByField({
            field: contractFields.REMPART.PCI_EXPIRATION_DATE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(contractFields.REMPART.PCI_EXPIRATION_DATE.key)} />
            ),
            show: show
        }),
        generateColumnDefByField({
            field: contractFields.REMPART.PCI_PP_VERSION,
            headerPackage: headerPackage,
            show: show
        }),
        generateColumnDefByField({
            field: contractFields.REMPART.PCI_PP_EXPIRATION_DATE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(contractFields.REMPART.PCI_PP_EXPIRATION_DATE.key)} />
            ),
            show: show
        }),
        generateColumnDefByField({
            field: contractFields.REMPART.EXPIRATION_DATE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(contractFields.REMPART.EXPIRATION_DATE.key)} />
            ),
            show: show
        }),
        generateColumnDefByField({
            field: contractFields.REMPART.END_OF_DEPLOYMENT_DATE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(contractFields.REMPART.END_OF_DEPLOYMENT_DATE.key)} />
            ),
            show: show
        }),
        generateColumnDefByField({
            field: contractFields.REMPART.END_OF_USE_DATE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(contractFields.REMPART.END_OF_USE_DATE.key)} />
            ),
            show: show
        })
    ].filter(col => !!col));
};